import * as React from 'react';
import { compose, withHandlers, withProps } from 'recompose';
import { withNotifications } from '@components/hoc/withNotifications';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import * as T from '@components/form/GPSBtn/_gpsBtn';

import { fetch } from '@utils/utils';

const enhance = compose<any, any>(
  withNotifications({}),
  withProps(({ handleCustomPlace, addError, handleLoader }) => ({
    onPosition: async ({ lat, lon }) => {
      try {
        handleLoader(true);
        const response = await fetch(`/metropolis/api/common/osm/find-location?lot=${lon}&lat=${lat}`, {
          method: 'GET',
          headers: new Headers({ Accept: '*/*' })
        });
        const address = await response.json();
        handleCustomPlace({ address });
      } catch (e) {
        addError('Nepovedlo se získat adresu z vašich souřadnic.');
        console.log(e);
      }
      handleLoader(false);
    }
  })),
  withHandlers({
    setGPSLocation: ({ onPosition, addError }) => async () => {
      navigator.geolocation.getCurrentPosition(
        position => {
          onPosition({
            lat: position.coords.latitude,
            lon: position.coords.longitude
          });
        },
        () => {
          addError('Nepovedlo se získat vaše souřadnice.');
        },
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      );
    }
  })
);

const GPSBtn: React.SFC<T.OutterProps & T.InnerProps> = ({ setGPSLocation, label }) => (
  <Button label={label} onClick={setGPSLocation} style={{ margin: '16px' }} />
);

export default enhance(GPSBtn);



// WEBPACK FOOTER //
// ./src/components/form/GPSBtn/GPSButton.tsx